import styled from 'styled-components'
import colors from '../../../configuration/colors'
import NewCloseSvg from './icon_clear_x.svg'
import NewCloseHoverSvg from './icon_clear_x_hover.svg'
import XSvg from '../../../static/images/X_Close.svg'
import TargetDateIcon from '../../../static/images/icons/icon-Level_Target_Date.svg'
import HourglassSvg from '../../../static/images/icons/hourglass_icon.svg'

const NewCloseIcon = styled.div`
  width: 12px;
  height: 11px;
  margin-top: 5px;
  background: 0 0 url(${NewCloseSvg}) no-repeat;

  &:hover {
    background: 0 0 url(${NewCloseHoverSvg}) no-repeat;
  }
`

const CloseIcon = styled.img.attrs({
  src: XSvg
})`
  width: 11px;
  height: 11px;
  vertical-align: middle;
`

const HourglassIcon = styled.img.attrs({
  src: HourglassSvg
})`
  width: 14.5px;
  height: 17px;
  margin-right: 10px;
`

const SetTargetDatesWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;

  .SingleDatePickerInput {
    .DateInput {
      width: 170px;
      border-radius: 5px;
    }
  }

  .SingleDatePickerInput_clearDate {
    margin: 0;
    outline: 0;
  }

  .SingleDatePickerInput,
  .DateInput_input {
    border-radius: 5px;
  }

  .CalendarDay__default:hover {
    color: ${colors.black};
  }

  .CalendarDay__selected:hover {
    color: ${colors.white};
  }
`

const TextEl = styled.div`
  display: ${props => props.display};
  padding-left: 20px;
  background: 0 50% url(${TargetDateIcon}) no-repeat;
  background-size: 16px 15px;
  line-height: inherit;
`

export { CloseIcon, NewCloseIcon, HourglassIcon, SetTargetDatesWrapper, TextEl }
